export default function (obj, locale) {
    if (!!locale.getProperty(obj, 'fullname')) return locale.getProperty(obj, 'fullname');

    const lastname = locale.getProperty(obj, 'lastname') || '';
    const name = locale.getProperty(obj, 'name') || '';
    const patronymic = locale.getProperty(obj, 'patronymic') || '';

    return [lastname, name, patronymic].filter(item => item?.length).join(" ");
    // return `${locale.getProperty(obj, 'lastname') || ''} ${locale.getProperty(obj, 'name') || ''} ${locale.getProperty(obj, 'patronymic') || ''}`;
}
